import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  blockWorkspace: {
    id: 'blockWorkspace',
    defaultMessage: 'Block workspace'
  },
  btnBlock: {
    id: 'btnBlock',
    defaultMessage: 'Block'
  }
});

export default { ...globalIntl, ...m };
